import { csv } from "./base";
import { concatModules } from "@/utility";

export const import_products = {
  namespaced: true,
  modules: {
    csv: csv("products")
  }
};
